export const ADD_ZONE_ERROR = 'ADD_ZONE_ERROR';
export const ADD_ZONE_LOADING = 'ADD_ZONE_LOADING';
export const ADD_ZONE_SUCCESS = 'ADD_ZONE_SUCCESS';

export const UPDATE_ZONE_ERROR = 'UPDATE_ZONE_ERROR';
export const UPDATE_ZONE_LOADING = 'UPDATE_ZONE_LOADING';
export const UPDATE_ZONE_SUCCESS = 'UPDATE_ZONE_SUCCESS';

export const FETCH_ZONE_ERROR = 'FETCH_ZONE_ERROR';
export const FETCH_ZONE_LOADING = 'FETCH_ZONE_LOADING';
export const FETCH_ZONE_SUCCESS = 'FETCH_ZONE_SUCCESS';

export const FETCH_BY_ID_ZONE_ERROR = 'FETCH_BY_ID_ZONE_ERROR';
export const FETCH_BY_ID_ZONE_LOADING = 'FETCH_BY_ID_ZONE_LOADING';
export const FETCH_BY_ID_ZONE_SUCCESS = 'FETCH_BY_ID_ZONE_SUCCESS';

export const DELETE_ZONE_ERROR = 'DELETE_ZONE_ERROR';
export const DELETE_ZONE_LOADING = 'DELETE_ZONE_LOADING';
export const DELETE_ZONE_SUCCESS = 'DELETE_ZONE_SUCCESS';

export const DELETE_ZONE_FAILURE = 'DELETE_ZONE_FAILURE';
export const FETCH_ZONE_FAILURE = 'FETCH_ZONE_FAILURE';
export const UPDATE_ZONE_FAILURE = 'UPDATE_ZONE_FAILURE';
